// Images
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/video-embed/ls.video-embed';
import 'lazysizes';
import 'picturefill';

import Vue from 'vue';
import InstantSearch from 'vue-instantsearch';
import InteractiveMap from '../components/clickable-map/ClickableMap';
import VueScrollTo from 'vue-scrollto'

// import * as VueGoogleMaps from 'vue2-google-maps';

// Vue.use(VueGoogleMaps, {
//     load: {
//         key: 'AIzaSyBP8PJ4lr8L8FsVXsHR3RXcVrlZY1OIuhE'
//     }
// });

Vue.use(InstantSearch);
Vue.use(VueScrollTo);

// Register all Vue components
const req = require.context('@components/', true, /\.(js|vue)$/i);

req.keys().map((key) => {
    const name = key.match(/\w+/)[0];
    return Vue.component(name, req(key).default)
});

Vue.config.devtools = true;
Vue.config.performance = true;

Vue.component('clickable-map', InteractiveMap);

new Vue({
    el: '#app',
    delimiters: ['{[{', '}]}'],
    data: {
        resourcesSearch: null,
        mounted: false
    },
    mounted() {
        this.mounted = true;
    }
});
